import $ from "jquery"

const onAddressCountryChange = (e) => {
  const select = e.currentTarget
  const $select = $(select)    
  const $form = $select.closest("form")
  const url = $form.data('url')
  $form.attr("action", url)
  $form.submit()
}
const onCheckoutFormSubmit = (e) => {
  document.documentElement.classList.add("index-loading")
}
const onSubmitPromoCodeClick = (e) => {
  e.preventDefault()
  const btn = e.currentTarget
  if (!btn) {
    return false
  }
  const url = btn.dataset.url
  const successStatus = btn.dataset.success
  const name = btn.dataset.inputName
  if (!url || !successStatus || !name) {
    return false
  }
  const input = document.querySelector("input[name='" + name + "']")
  if (!input) {
    return false
  }
  const value = input.value
  if (!value) {
    return false
  }
  const msgSelector = btn.dataset.msgSelector
  let msgWrapper = false    
  if (msgSelector) {
    msgWrapper = document.querySelector(msgSelector)
  }
  let params = {}
  params[name] = value
  $.post(url, params, (result) => {
    // const json = JSON.parse(result)
    const json = result
    if (!json) {
      return false
    }
    if (!json.respond_code) {
      return false
    }
    if (json.respond_code == successStatus) {
      // Success! - redirect
      if (msgWrapper) {
        msgWrapper.classList.add("d-none")
        msgWrapper.textContent = ""
        const $form = $(btn).closest("form")
        const url = $form.data('url')
        $form.attr("action", url)
        $form.submit()
      }

    } else if (json.alerts) {
      // Error msg
      if (json.alerts.length) {
        console.warn(json.alerts[0])
        if (msgWrapper) {
          msgWrapper.textContent = json.alerts[0]
          msgWrapper.classList.remove("d-none")
        }
      }
    }
  })
}
const onInputFormExpandChange = (e) => {
  let trigger = e.currentTarget
  let selectorFrom = trigger.dataset.formExpand
  let selectorInto = trigger.dataset.formWrapper
  if (selectorFrom && selectorInto) {
    const $from = $(selectorFrom)
    const $into = $(selectorInto)
    if ($from.length && $into.length) {
      if (trigger.checked) {
        $into.html($from.html())
      } else {
        $into.html("")
      }
      // windowUpdate()
    }
  }
}

const addEventListeners = () => {
  // address country change & shipping method change (POST submit)
  $('body').on('change', 'select[name="ship_address_address_country"], input[name="shipping_method"]', onAddressCountryChange)
  // on form submit
  $('body').on('submit', '.eccart-checkout-form form', onCheckoutFormSubmit)
  // promo code
  $('body').on('click', '#submit-promo-code', onSubmitPromoCodeClick);
  // on invoice form checkbox change
  $('body').on('change', "input[data-form-expand]", onInputFormExpandChange)
}

const inPostFix = () => {
  $('body').on('mouseover', '.list-point-link', (e) => {
    e.currentTarget.classList.add("no-as")
  })
  
}

// # init Checkout
export const initCheckout = () => {
  // add event listeners
  addEventListeners();
  inPostFix();
}



